'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _deviceDetection = require('./utils/device-detection');

var _ui = require('./ui/ui.controler');

var _ui2 = _interopRequireDefault(_ui);

var _playbackEngine = require('./playback-engine/playback-engine');

var _playbackEngine2 = _interopRequireDefault(_playbackEngine);

var _anomalyBloodhound = require('./anomaly-bloodhound/anomaly-bloodhound');

var _anomalyBloodhound2 = _interopRequireDefault(_anomalyBloodhound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Player = function () {
  function Player(config) {
    _classCallCheck(this, Player);

    this._config = config;

    var _config = this._config,
        preload = _config.preload,
        autoPlay = _config.autoPlay,
        loop = _config.loop,
        muted = _config.muted,
        volume = _config.volume,
        src = _config.src,
        size = _config.size,
        playInline = _config.playInline,
        controls = _config.controls,
        overlay = _config.overlay,
        loader = _config.loader,
        logger = _config.logger,
        screen = _config.screen,
        _config$customUI = _config.customUI,
        customUI = _config$customUI === undefined ? {} : _config$customUI;


    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);

    this._eventEmitter = new _eventemitter2.default();
    this._engine = new _playbackEngine2.default({
      eventEmitter: this._eventEmitter
    });

    this._createUI(size, controls, overlay, loader, screen, customUI);

    if (logger) {
      this._anomalyBloodhound = new _anomalyBloodhound2.default({
        eventEmitter: this._eventEmitter,
        engine: this._engine,
        config: logger
      });
    }

    this.setPreload(preload);

    if (autoPlay) {
      this.setAutoPlay(true);
    }

    if (loop) {
      this.setLoop(true);
    }

    if (muted) {
      this.setMute(true);
    }

    if (volume) {
      this.setVolume(volume);
    }

    if (playInline) {
      this.setPlayInline(playInline);
    }

    if (src) {
      this.setSrc(src);
    }
  }

  _createClass(Player, [{
    key: '_createUI',
    value: function _createUI(size, controls, overlay, loader, screen, customUI) {
      var config = _extends({}, size, {
        overlay: overlay,
        screen: screen,
        customUI: customUI
      });

      if (_deviceDetection.iPhone || _deviceDetection.iPod || _deviceDetection.Android) {
        config.screen = _extends({}, screen, {
          indicateScreenClick: false,
          disableClickProcessing: true,
          nativeControls: true
        });
        config.loader = false;
        config.controls = false;
      } else {
        config.loader = loader;
        config.controls = controls;
      }

      this.ui = new _ui2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        config: config
      });
    }
  }, {
    key: 'setAutoPlay',
    value: function setAutoPlay(isAutoPlay) {
      this._engine.setAutoPlay(isAutoPlay);
    }
  }, {
    key: 'getAutoPlay',
    value: function getAutoPlay() {
      return this._engine.getAutoPlay();
    }
  }, {
    key: 'setLoop',
    value: function setLoop(isLoop) {
      this._engine.setLoop(isLoop);
    }
  }, {
    key: 'getLoop',
    value: function getLoop() {
      return this._engine.getLoop();
    }
  }, {
    key: 'setMute',
    value: function setMute(isMuted) {
      this._engine.setMute(isMuted);
    }
  }, {
    key: 'getMute',
    value: function getMute() {
      return this._engine.getMute();
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      this._engine.setVolume(volume);
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this._engine.getVolume();
    }
  }, {
    key: 'setPreload',
    value: function setPreload(preload) {
      this._engine.setPreload(preload);
    }
  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this._engine.getPreload();
    }
  }, {
    key: 'setSrc',
    value: function setSrc(src) {
      this._engine.setSrc(src);
    }
  }, {
    key: 'setPlayInline',
    value: function setPlayInline(isPlayInline) {
      this._engine.setPlayInline(isPlayInline);
    }
  }, {
    key: 'getPlayInline',
    value: function getPlayInline() {
      this._engine.getPlayInline();
    }
  }, {
    key: 'on',
    value: function on(name, callback) {
      this._eventEmitter.on(name, callback);
    }
  }, {
    key: 'off',
    value: function off(name, callback) {
      this._eventEmitter.off(name, callback);
    }
  }, {
    key: 'play',
    value: function play() {
      this._engine.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._engine.pause();
    }
  }, {
    key: '_unbindAllEvents',
    value: function _unbindAllEvents() {
      var _this = this;

      var eventsName = this._eventEmitter.eventNames();

      eventsName.forEach(function (eventName) {
        _this._eventEmitter.removeAllListeners(eventName);
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.ui.destroy();
      delete this.ui;

      this._unbindAllEvents();
      delete this._eventEmitter;

      this._engine.destroy();
      delete this._engine;

      if (this._anomalyBloodhound) {
        this._anomalyBloodhound.destroy();
        delete this._anomalyBloodhound;
      }
    }
  }, {
    key: 'node',
    get: function get() {
      if (!this.ui) {
        return;
      }

      return this.ui.node;
    }
  }]);

  return Player;
}();

exports.default = Player;
//# sourceMappingURL=player.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/player.js
// module id = 1694
// module chunks = 1 2 3